/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const Close: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="close" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M1080.69 1000.5633333333332L760.1266666666667 680L1080.6899999999998 359.4366666666667L1000.563333333333 279.31L680 599.8733333333333L359.4366666666667 279.3100000000002L279.31 359.436666666667L599.8733333333333 680L279.31 1000.5633333333332L359.4366666666667 1080.6333333333334L680 760.1266666666667L1000.5633333333332 1080.69L1080.69 1000.5633333333332z" : "M864.5520000000001 800.4506666666666L608.1013333333334 544L864.5519999999999 287.5493333333333L800.4506666666665 223.4479999999999L544 479.8986666666666L287.5493333333333 223.4480000000001L223.448 287.5493333333335L479.8986666666667 544L223.448 800.4506666666666L287.5493333333333 864.5066666666667L544 608.1013333333333L800.4506666666667 864.5519999999999L864.5520000000001 800.4506666666666z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
Close.displayName = `Blueprint5.Icon.Close`;
export default Close;
